import * as React from "react";

// Components
import IconInfo from "../Icons/IconInfo";

const MoreInfoTrigger: React.FC = () => {
  return (
    <button
      type="button"
      className=" font-bold text-dw-blue text-s cursor-pointer inline-flex items-center mb-1"
    >
      <IconInfo style={{ marginRight: "5px" }} />
      more information
    </button>
  );
};

export default MoreInfoTrigger;
